import { z } from 'zod';
import { defineEndpoint } from '../define';

export const deleteAppleUdid = defineEndpoint({
  method: 'DELETE',
  path: '/v1/apple-udids/:udidId',
  params: z.object({ udidId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
